import React, { Component } from "react";

class LenderResultRowDetailV2 extends Component {
  constructor(props) {
    super(props);
    this.counter = 0;
    this.state = {
      tabIndex : true,
      showLenderInfo: true
    }
    this.handleOfferDetailToggle = this.handleOfferDetailToggle.bind(this);
    this.handleTabDetailToggle = this.handleTabDetailToggle.bind(this);
  }

  handleOfferDetailToggle(event) {
    this.props.onHideDetailClick(event);
  }
  handleTabDetailToggle() {
    if(this.state.showLenderInfo){
      this.setState({tabIndex: !this.state.tabIndex});
    }
  }

  generateHideDetailLink() {
    const lenderId = this.props.lenderId;
    this.counter = this.counter + 1;
    return (
      <a key={"detail-div-a-" + this.counter + "-" + lenderId}
        href={`#${lenderId}`}
        onClick={this.handleOfferDetailToggle} >
        {this.props.toggleOfferDetailLabel}
      </a>
    );
  }

  render() {
    const lenderId = this.props.lenderId;
    let qualification = [], keyFacts = [],pros = [],cons = [];   
    let aboutDeails;
     this.props.offerDetail.forEach((data)=> {
        
        if(data.title ==  'Qualifications')
          qualification =  data;
        else if(data.title ==  'Key Facts')
          keyFacts =  data;
        // else if(data.title == 'About')
        // aboutDeails =  data.text;
        // else if(data.title ==  'Pros')
        //   pros =  data;
        // else if(data.title ==  'Cons')
        //   cons =  data;
      });
      console.log(aboutDeails);

    const LenderDetails = document.querySelector(
      ".mp-lenders-hidden #" + lenderId.toUpperCase()
    )
      ? document.querySelector(".mp-lenders-hidden #" + lenderId.toUpperCase())
          .innerHTML
      : "";

    const qualificationBullets = [];
    qualification.bullets.forEach((bullet, index) => {
      qualificationBullets.push(<li className="" key={index}>{bullet}</li>);
    });

    const prosBullets = [];
    // pros.bullets.forEach((bullet, index) => {
    //   prosBullets.push(<li className="offerdetails prosText" key={index}>{bullet}</li>);
    // });

    const consBullets = [];
    // cons.bullets.forEach((bullet, index) => {
    //   consBullets.push(<li className="offerdetails consText" key={index}>{bullet}</li>);
    // });

    const keyFactsBullets = [];
    keyFacts.bullets.forEach((bullet, index) => {
      keyFactsBullets.push(<li className="" key={index}>{bullet}</li>);
    });

    

    if (!this.props.isDetailExpanded) {
      return null;
    }
    
    let disclaimerHideLink = "";
    if (this.props.disclaimer !== null) {
      disclaimerHideLink = this.generateHideDetailLink();
    }
    // if( ( !aboutDeails || aboutDeails.toLowerCase().indexOf('coming soon...') != -1) && 
    //   ( prosBullets.length == 0 || prosBullets[0].props.children.replaceAll(' ','').length == 0 || prosBullets[0].props.children.toLowerCase().indexOf('coming soon...') != -1) && 
    //   ( consBullets.length == 0 || consBullets[0].props.children.replaceAll(' ','').length == 0 || consBullets[0].props.children.toLowerCase().indexOf('coming soon...') != -1) ){
    //   this.state.showLenderInfo = this.state.tabIndex = false
    // } 
    if( !LenderDetails ){
      this.state.showLenderInfo = this.state.tabIndex = false
    } 
    return (
      <div
        key={"detail-div-" + lenderId}
        className={` ${this.props.rowClass}`} >
        <div class="clearfix"></div>
        <div className="row desktopbg">  
          <div className={`col-md-12 nopadding`}>
            <ul id="lenderInfoTabs" className="">
              {  this.state.showLenderInfo && <li 
                onClick={this.handleTabDetailToggle} 
                className={this.state.tabIndex ? "active-tab" : ""}>
                  Lender Information</li> }
              <li 
                onClick={this.handleTabDetailToggle} 
                className={this.state.tabIndex ? "" : "active-tab"}>
                  Qualifications</li>
            </ul>
          </div>
        </div>
        <div className="row desktopbg">
          {this.state.tabIndex ?
            // Lender Information
            <div>
              <div className={`col-md-12 nopadding`}>
                {<div dangerouslySetInnerHTML={{ __html: LenderDetails }} />}
              </div>
              {/* { aboutDeails && aboutDeails.toLowerCase().indexOf('coming soon...') == -1 && <div className={`col-md-12 `}>
                <h4 key={"detail-div-h4-2-" + lenderId} className="offerdetailTitle">About</h4>
                {aboutDeails !== null ? (
                  <div className="offerdetails aboutText"
                    key={"detail-div-p-" + lenderId} 
                    dangerouslySetInnerHTML={{ __html: aboutDeails }} >
                  </div> ) 
                : "" }
              </div> } */}
              <div class="clearfix"></div>
              {/* { ( (prosBullets.length != 0 && prosBullets[0].props.children.replaceAll(' ','') && prosBullets[0].props.children.toLowerCase().indexOf('coming soon...') == -1 ) || 
                (consBullets.length != 0 && consBullets[0].props.children.replaceAll(' ','') && consBullets[0].props.children.toLowerCase().indexOf('coming soon...') == -1 ) )&&<div>
                <div className={`col-md-6 col-sm-6 col-xs-12 `}>
                  <h4 key={"detail-div-h4-2-" + lenderId} className="offerdetailTitle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <path d="M20 6L9 17l-5-5" /> </svg> {pros.title}</h4>
                  <ul className={`row-detail prosList`} key={"detail-div-ul-2-" + lenderId}>
                  {prosBullets}
                  </ul>
                </div>
                <div className={`col-md-6 col-sm-6 col-xs-12 `}>
                  <h4 key={"detail-div-h4-" + lenderId} className="offerdetailTitle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <path d="M18 6L6 18M6 6l12 12" /> </svg> {cons.title}</h4>
                  <ul className={`row-detail consList`} key={"detail-div-ul-" + lenderId}>
                  {consBullets}
                  </ul>
                </div>
              </div> } */}
            </div>
            
          :
          // Qualifications
          <div>
            <div className={`col-md-6 col-sm-6 col-xs-12 `}>
              <h4 key={"detail-div-h4-" + lenderId} className="offerdetailTitle">{qualification.title}</h4>
              <ul className={`row-detail offerdetails qualifications liststyle`} key={"detail-div-ul-" + lenderId}>
                {qualificationBullets}
              </ul>
            </div>
            <div className={`col-md-6 col-sm-6 col-xs-12 `}>
              <h4 key={"detail-div-h4-2-" + lenderId} className="offerdetailTitle">{keyFacts.title}</h4>
              <ul className={`row-detail offerdetails keyfacts liststyle`} key={"detail-div-ul-2-" + lenderId}>
              {keyFactsBullets}
              </ul>
            </div>
            <div class="clearfix"></div>
            <div className={`col-md-12 `}>
              {this.props.disclaimer !== null ? (
                <div
                  key={"detail-div-p-" + lenderId} 
                  dangerouslySetInnerHTML={{ __html: this.props.disclaimer }} >
                </div> ) 
              : "" }
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default LenderResultRowDetailV2;



// WEBPACK FOOTER //
// ./src/LenderResultRowDetailV2.js